import { Interval } from 'app/agriculture/AgTimeline/types';
import { differenceInMilliseconds } from 'date-fns';

// The distance from 'now' that the timeline scrubber should be before it snaps
// Expressed as a percentage of the timeline interval
const VARIANCE = 0.01;

// Checks how close the timeline cursor is to 'now' and then snaps to 'undefined' if closer than the VARIANCE
export function snappedCursorTime(
    cursorTime: Date,
    timelineInterval: Interval<Date>,
): Date | undefined {
    const differenceFromNow = differenceInMilliseconds(cursorTime, new Date());
    const intervalLength = differenceInMilliseconds(timelineInterval.end, timelineInterval.start);
    const diffPercentage = differenceFromNow / intervalLength;

    // if the difference between now and cursorTime is positive and less than the variance, then snap
    if (0 < diffPercentage && diffPercentage < VARIANCE) return undefined;

    // if the difference between now and cursorTime is negative, then we are in the future, so snap
    if (diffPercentage > 0) return undefined;

    return cursorTime;
}
